import React from "react";
import { Form, Col } from "react-bootstrap";

const valueStyles = {
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  hyphens: 'none',
}

export default class BaseField extends React.Component {

  renderShow() {
    const { col, value, label, isStaffApp } = this.props;

    if (value) {
      return isStaffApp ?
      (
        <div className="item d-flex justify-content-between align-items-center pb-4">
          <div className="text-secondary unselectable">{ label }</div>
          <div className="">{ value }</div>
        </div>
      )
      : (
        <Col sm={col == 'none' ? null : (col || 3)}>
          <div className="p-2">
            <div><strong>{label}</strong></div>
            <div style={valueStyles}>{value}</div>
          </div>
        </Col>
      );
    }
    return null;
  }

  renderEdit() {
    const { resource, name, label, value, col, onChange, required } = this.props;

    return (<>
      <Col sm={col == 'none' ? 'null' : (col || 3) }>
        <Form.Group controlId={`${resource}_${name}`}>
          <Form.Label>{required ? <abbr title="required">*</abbr> : ''} {label}</Form.Label>
          { this.props.children }
        </Form.Group>
      </Col>
      </>
    );
  }

  render() {
    const { action } = this.props;

    if (action == "show") {
      return this.renderShow();
    } else if (action == "edit") {
      return this.renderEdit();
    }
  }
}